import * as React from 'react';
import { Typography, WithStyles, withStyles,} from '@material-ui/core';
import { IEcoPurchase, IEcoTransfer, IEcoSplitSetting} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import { ecoContainerStyle } from './Container.style';
import ListItemPurchase from './ListItemPurchase';
import ListItemTransfer from './ListItemTransfer';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ecoContainerStyle>
{
    disputedPurchases: IEcoPurchase[];
    disputedTransfers: IEcoTransfer[];
    family: IFamilyMember[];
    userId:number;
    settings:IEcoSplitSetting[];
    currency:string;
    
    edit: (purchase:IEcoPurchase) => void;
    editTransfer: (transfer:IEcoTransfer) => void;
    seen: (purchaseId:number) => void;
    seenTransfer: (transferId:number) => void;

    scrollTime:number;
    doScroll:boolean;

    waitForPurchaseChat:(id:number) => void;
    waitForTransferChat:(id:number) => void;

    disputedByMe:boolean;
}


class ContainerDisputedTransactions extends React.Component<IProps> {

    public render()
    {
        const { classes, disputedPurchases, disputedTransfers, userId, family,settings, 
            currency, scrollTime, edit, editTransfer, seen, seenTransfer } = this.props;

        const thisMonthsPurchases:IEcoPurchase[] = disputedPurchases;
        const thisMonthsTransfers:IEcoTransfer[] = disputedTransfers;
        
        thisMonthsPurchases.sort((a,b) => a.date-b.date);
        thisMonthsTransfers.sort((a,b) => a.date-b.date);

        let pIndex = 0;
        let tIndex = 0;
        const transactions:JSX.Element[] = [];
        while (pIndex < thisMonthsPurchases.length || tIndex < thisMonthsTransfers.length) {
            if (pIndex < thisMonthsPurchases.length && tIndex < thisMonthsTransfers.length) {
                if (thisMonthsPurchases[pIndex].date < thisMonthsTransfers[tIndex].date) {
                    const purchase = thisMonthsPurchases[pIndex];
                    transactions.push(<ListItemPurchase  key={"p"+purchase.id} currency={currency} family={family} userId={userId} 
                        waitForPurchaseChat={this.props.waitForPurchaseChat}
                        settings={settings} edit={edit} purchase={purchase} seen={seen} scrollTime={scrollTime}/>);
                    pIndex+=1;
                } else {
                    const transfer = thisMonthsTransfers[tIndex];
                    transactions.push(<ListItemTransfer currency={currency} family={family} userId={userId} scrollTime={scrollTime} 
                        waitForTransferChat={this.props.waitForTransferChat}
                        settings={settings} key={"t"+transfer.id} editTransfer={editTransfer} transfer={transfer} seenTransfer={seenTransfer}/>);
                    tIndex+=1;
                }
            } else if (pIndex < thisMonthsPurchases.length) {
                const purchase = thisMonthsPurchases[pIndex];
                transactions.push(<ListItemPurchase key={"p"+purchase.id} currency={currency} family={family} userId={userId} 
                    waitForPurchaseChat={this.props.waitForPurchaseChat}
                    settings={settings} edit={edit} purchase={purchase} seen={seen} scrollTime={scrollTime}/>);
                pIndex+=1;
            } else if (tIndex < thisMonthsTransfers.length) {
                const transfer = thisMonthsTransfers[tIndex];
                transactions.push(<ListItemTransfer currency={currency} family={family} userId={userId} scrollTime={scrollTime}
                    waitForTransferChat={this.props.waitForTransferChat}
                    settings={settings}  key={"t"+transfer.id} editTransfer={editTransfer} transfer={transfer} seenTransfer={seenTransfer}/>);
                tIndex+=1;
            }
        }            

        return (
            <div className={classes.container} style={{flexDirection: 'column',flexWrap:'unset',}}>
                <div className={classes.titleWrapper}>
                    <Typography className={classes.heading1} gutterBottom={false} component={'div'} style={{display:'flex'}}>
                        {this.props.disputedByMe?tn.lang.disputedTransactionsByMe:tn.lang.disputedTransactions}
                        <div className={classes.badge}>{transactions.length}</div>
                    </Typography>
                    
                </div>
                <div className={classes.card}>
                    {transactions}
                </div>                
            </div>
        );
    }
}

export default withStyles(ecoContainerStyle)(ContainerDisputedTransactions);



// WEBPACK FOOTER //
// ./src/components/economy/ContainerDisputedTransactions.tsx